<template>
  <div class="dialog-overlay" @click="closeDialog">
    <div class="dialog-container" @click.stop>
      <!-- 标题 -->
      <div class="title-text">{{ $t('student.qa.title') }}</div>
      
      <!-- 关闭按钮 -->
      <img 
        class="close-btn" 
        src="@/assets/全球说/close.png" 
        @click="closeDialog"
        alt="关闭"
      />
      
      <!-- 聊天区域 -->
      <div class="chat-area">
        <div class="chat-messages" ref="chatMessages">
          <!-- 默认老师消息 -->
          <div class="message teacher-message">
            <img 
              class="avatar teacher-avatar" 
              :src="messages.length > 0 && messages.find(m => m.type === 'teacher' && m.imgUrl) ? messages.find(m => m.type === 'teacher' && m.imgUrl).imgUrl : ''"
              alt="老师头像"
              v-if="messages.length > 0 && messages.find(m => m.type === 'teacher' && m.imgUrl)"
            />
            <div class="message-bubble teacher-bubble">
              {{ $t('student.qa.input_hint') }}
            </div>
          </div>
          
          <!-- 动态消息列表 -->
          <div 
            v-for="(message, index) in messages" 
            :key="index"
            :class="['message', message.type === 'student' ? 'student-message' : 'teacher-message']"
          >
            <img 
              v-if="message.type === 'teacher' && message.imgUrl"
              class="avatar teacher-avatar" 
              :src="message.imgUrl"
              alt="老师头像"
            />
            <img 
              v-if="message.type === 'student'"
              class="avatar student-avatar" 
              src="@/assets/全球说/student.png"
              alt="学生头像"
            />
            <div :class="['message-bubble', message.type === 'student' ? 'student-bubble' : 'teacher-bubble']">
              <div v-if="message.isAudio" style="display:flex;align-items:center;gap:8px;max-width:100%">
                <audio :src="message.audioUrl" controls style="max-width:100%"></audio>
              </div>
              <span v-else>{{ message.content }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 输入区域 - 推流时隐藏 -->
      <div v-if="!isStreaming" class="input-area">
        <div class="input-container">
          <!-- 文字输入模式 -->
          <div v-if="!isVoiceMode" class="text-input-container">
            <textarea 
              v-model="inputText"
              class="text-input"
              :placeholder="$t('student.qa.input_hint')"
              @input="onInputChange"
            ></textarea>
            <div class="input-controls">
              <img 
                class="control-icon" 
                src="@/assets/全球说/micphone.png" 
                @click="switchToVoiceMode"
                alt="语音输入"
              />
              <div class="control-divider"></div>
              <img 
                class="control-icon" 
                src="@/assets/全球说/navigation.png" 
                @click="sendTextMessage"
                alt="发送"
              />
            </div>
          </div>
          
          <!-- 语音输入模式 -->
          <div v-else class="voice-input-container">
            <div class="voice-input-area">
              <img 
              :src="isRecording ? require('@/assets/全球说/audio-stop.png') : require('@/assets/全球说/audio-play.png')"
              class="voice-record-icon"
              @click="toggleRecording"
              :alt="isRecording ? '停止录音' : '开始录音'"
            />
            </div>
            <div class="input-controls">
              <div class="control-divider"></div>
              <img 
                class="control-icon" 
                src="@/assets/全球说/Keyboard-one.png" 
                @click="switchToTextMode"
                alt="键盘输入"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChineseAskingDialog',
  props: {
    askingData: {
      required: true
    },
    channel: null,
    mainObj: null,
  },
  data() {
    return {
      messages: [],
      inputText: '',
      isVoiceMode: false,
      isRecording: false,
      userAsking: {},
      dialogueId: null // 存储对话ID
    };
  },
  computed: {
    isStreaming() {
      // 参考TeacherAskingDialog的实现，检查用户提问的推流状态
      return this.userAsking.bHandling || this.userAsking.bShowThinking || (this.mainObj && this.mainObj.isStreaming);
    }
  },
  watch: {
    askingData: {
      immediate: true,
      handler(newContent) {
        this.userAsking = newContent;
      }
    }
  },
  async mounted() {
    // 弹窗呼出时调用create-qa-dialogue接口获取对话ID
    await this.createQaDialogue();
  },
  methods: {
    closeDialog() {
      this.userAsking.bPlaying = false;
      if(this.userAsking.qaUsingVideoOrCartoon) {
        this.mainObj.stopUserAskingQuestionsVideo();
      }
      if(this.userAsking.lastAnswerPlayer) {
        this.mainObj.stopMediaPlayer(this.userAsking.lastAnswerPlayer);
      }
      let img = document.getElementById('qaTriggerImage');
      if(img) img.src = this.channel.userAskTriggerWantToAskImg(this.mainObj.queries.lessonId);
      this.userAsking.photoBase64Data = '';
      this.userAsking.bShowView = false;
    },
    
    switchToVoiceMode() {
      this.isVoiceMode = true;
    },
    
    switchToTextMode() {
      this.isVoiceMode = false;
      this.isRecording = false;
      // 确保录音状态也被重置
      if (this.mainObj.bAudioRecording) {
        // 通过方法调用而不是直接修改props
        this.resetRecordingState();
      }
    },
    
    resetRecordingState() {
      // 重置录音状态的辅助方法
      if (this.mainObj.bAudioRecording) {
        // 使用 Vue.set 或者通过父组件方法来修改状态
        this.$set(this.mainObj, 'bAudioRecording', false);
        if (this.mainObj.audioRecorderTimer) {
          clearInterval(this.mainObj.audioRecorderTimer);
          this.$set(this.mainObj, 'audioRecorderTimer', null);
        }
      }
    },
    
    toggleRecording() {
      if (!this.isRecording) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    },
    
    startRecording() {
      console.log('startRecording 被调用，当前状态:', this.isRecording);
      if (!this.isRecording) {
        this.isRecording = true;
        // 直接调用录音逻辑，不通过onUserClickAudioInputForUserAsking
        this.handleRecordingProcess();
      }
    },
    
    stopRecording() {
      console.log('stopRecording 被调用，当前状态:', this.isRecording, '实际录音状态:', this.mainObj.bAudioRecording);
      this.isRecording = false;
      // 手动停止录音
      if (this.mainObj.bAudioRecording) {
        // 调用录音处理逻辑来正确停止录音
        this.handleRecordingProcess();
      }
    },
    
    sendTextMessage() {
      if (!this.inputText.trim()) return;
      
      // 添加学生消息到聊天区域
      this.messages.push({
        type: 'student',
        content: this.inputText
      });
      
      // 发送消息
      this.onUserClickSendQuestionInner(this.inputText);
      
      // 清空输入框
      this.inputText = '';
      
      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    
    onInputChange() {
      // 可以在这里添加字数统计等逻辑
    },
    
    scrollToBottom() {
      const chatMessages = this.$refs.chatMessages;
      if (chatMessages) {
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }
    },
    
    // 创建问答对话，获取dialogueId
    async createQaDialogue() {
      try {
        const { createQaDialogue } = await import('@/util/readapi');
        const createReq = {
          draftId: this.mainObj.queries.lessonId,
          sceneIdx: this.mainObj.currentSceneId,
          groupIdx: this.mainObj.currentGroupId,
          actionIdx: this.userAsking.currentAction.actionId,
          type: "user_ask"
        };
        
        return new Promise((resolve, reject) => {
          createQaDialogue(this.mainObj.queries, createReq, this.mainObj.toLogin,
            (res) => {
              if (res.data.code === 0) {
                this.dialogueId = res.data.data;
                console.log('dialogueId:', this.dialogueId);
                resolve(this.dialogueId);
              } else {
                console.error('创建用户提问对话失败:', res.data.msg);
                reject(new Error(res.data.msg));
              }
            },
            (err) => {
              console.error('创建用户提问对话请求失败:', err);
              reject(err);
            }
          );
        });
      } catch (error) {
        console.error('调用create-qa-dialogue接口失败:', error);
        throw error;
      }
    },
    
    // 复用原组件的语音输入逻辑
    onUserClickAudioInputForUserAsking() {
      // 这个方法保持原有的切换逻辑，用于兼容其他调用
      this.handleRecordingProcess();
    },
    
    // 新的录音处理方法，解决状态冲突问题
    handleRecordingProcess() {
      if(this.userAsking.lastAnswerPlayer) {
        this.mainObj.stopMediaPlayer(this.userAsking.lastAnswerPlayer);
      }
      let thiz = this;
      let mainObj = this.mainObj;
      let begin = 0;
      
      let onRecordStarted = function (beginTimeMillis) {
        begin = beginTimeMillis;
        mainObj.audioRecorderSeconds = 60;
        // 确保UI状态同步
        thiz.isRecording = true;
      };
      
      let onRecordWavFile = function(file) {
        thiz.isRecording = false;
        let url = '';
        try { url = URL.createObjectURL(file); } catch(e) {void 0}
        if (url) {
          thiz.messages.push({ type: 'student', isAudio: true, audioUrl: url });
          thiz.$nextTick(() => { thiz.scrollToBottom(); });
        }
        thiz.$nextTick(() => {
          mainObj.voiceToText(file, thiz.userAsking.currentAction, function(text) {
            if (!text || text.trim() === '') {
              thiz.switchToTextMode();
              return;
            }
            thiz.onUserClickSendQuestionInner(text);
            thiz.switchToTextMode();
          });
        });
      };
      
      let onRecordDuration = function (durationTimeMillis) {
        let seconds = (durationTimeMillis - begin) / 1000;
        mainObj.audioRecorderSeconds = 60 - seconds;
        if(thiz.mainObj.audioRecorderSeconds <= 0) {
          mainObj.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
        }
      };

      // 确保录音状态正确管理
      console.log('当前录音状态:', mainObj.bAudioRecording, '组件录音状态:', thiz.isRecording);
      
      // 如果组件状态显示正在录音，但实际没有录音，则开始录音
      if (thiz.isRecording && !mainObj.bAudioRecording) {
        console.log('开始录音');
        mainObj.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
      }
      // 如果组件状态显示不在录音，但实际在录音，则停止录音
      else if (!thiz.isRecording && mainObj.bAudioRecording) {
        console.log('停止录音');
        mainObj.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
      }
      // 如果都没有录音，则开始录音
      else if (!thiz.isRecording && !mainObj.bAudioRecording) {
        console.log('开始新录音');
        thiz.isRecording = true;
        mainObj.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
      }
    },
    
    // 复用原组件的发送问题逻辑
    async onUserClickSendQuestionInner(qaText) {
      console.log("onUserClickSendQuestion:", qaText);
      
      // 设置推流状态
      this.userAsking.bHandling = true;
      this.userAsking.bShowThinking = true;
      
      this.userAsking.qaAnswer = '';
      this.userAsking.markdown = '';
      let jxgbox = document.getElementById('jxgbox');
      if(jxgbox) {
        jxgbox.innerHTML = '';
      }
      if (!qaText && !this.userAsking.photoBase64Data) {
        this.userAsking.bHandling = false;
        this.userAsking.bShowThinking = false;
        return;
      }
      
      let param = {
        robotStyle: this.userAsking.currentAction.robotStyle,
        voiceActor: this.userAsking.currentAction.voiceActor,
        volume    : this.userAsking.currentAction.volume,
        sectionId : this.userAsking.currentAction.sectionId || 0,
        sections  : this.userAsking.currentAction.sections,
        qaText    : qaText,
        photoBase64: this.userAsking.photoBase64Data,
        dialogueId: this.dialogueId, // 添加对话ID参数
        workflowId: this.userAsking.currentAction.workflowId
      };

      let thiz = this;
      let mainObj = this.mainObj;

      // 播放思考音效
      let idx = Math.round(Math.random());
      let mp3_url = idx==0 ? require('@/assets/robot_thinking_1.mp3') : require('@/assets/robot_thinking_2.mp3');
      let robot_voice_player_a = mainObj.playSound(mp3_url, () => {
        robot_voice_player_a.play().catch(async function (err) {
          console.error('play robot-voice-a error:', err, err.name, err.message);
        });
      });
      robot_voice_player_a.volume = robot_voice_player_a.volume / 2 / 3 / 2 / 2;

      // 使用stream API
      const { invokeLessonPlayerStreamWebApi } = await import('@/util/readapi');
      const { sleep } = await import('@/util/util');
      
      const stop_robot_voice_player_a = function () {
        if (robot_voice_player_a) {
          robot_voice_player_a.pause();
          mainObj.freeStaticAudioPlayer(robot_voice_player_a);
          robot_voice_player_a = null;
        }
      };

      let queue = [];
      let bDone = false;
      
      invokeLessonPlayerStreamWebApi(mainObj.queries, 'user-ask-workflow', param, thiz.toLogin,
          (oneObj)=>{
            if(oneObj.qaTextAdj) {
              // 处理调整后的问题文本
            }
            else if(oneObj.isGptWholeReply) {
              console.log('GG-all-chinese:', oneObj.reply);
            }
            else if(oneObj.isTarget) {
              console.log('GG-target-chinese:', oneObj.target);
            }
            else {
              console.log('GG-item-chinese:', oneObj.audioText);
              stop_robot_voice_player_a();
              queue.push(oneObj);
              
              // 不立即添加文字，等待语音播放时再添加
            }
          },
          (err)=>{
            stop_robot_voice_player_a();
            bDone = true;
            if (err) {
              console.log(err);
            }
            
            // 重置推流状态
            thiz.userAsking.bHandling = false;
            thiz.userAsking.bShowThinking = false;
            
            // 推流内容已在处理过程中逐条添加到聊天区域
            // 这里只需要确保最终滚动到底部
            thiz.$nextTick(() => {
              thiz.scrollToBottom();
            });
          }
      );

      let idx2 = 0;
      while (thiz.userAsking.bPlaying && (!bDone || idx2 < queue.length)) {
        if (idx2 < queue.length) {
          let item = queue[idx2];
          if (item.audioText && item.audioUrl) {
            // 先添加文字到聊天区域
            const displayText = item.dispText || item.audioText;
            thiz.messages.push({
              type: 'teacher',
              content: displayText
            });
            
            // 等待文字完全显示在UI上后再播放音频
            await thiz.$nextTick();
            thiz.scrollToBottom();
            await sleep(100);
            console.log('✅ 文字UI更新完成，开始播放音频');
            
            await mainObj.playUserAskingQuestionsCartoon(item.audioUrl);
            if(thiz.userAsking.bPlaying)
              await sleep(1000);
          }
          idx2++;
        }
        else if(thiz.userAsking.bPlaying) {
          await sleep(500);
        }
      }
    }
  }
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-container {
  width: 60%;
  max-width: 800px;
  aspect-ratio: 1330/733;
  background-image: url('@/assets/全球说/ques-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.title-text {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: #734719;
  background-image: url('@/assets/全球说/zhuangshi.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 4px bottom;
  z-index: 10;
  font-weight: bold;
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 10;
}

.chat-area {
  flex: 1;
  padding: 20px;
  margin-top: 80px;
  overflow: hidden;
}

.chat-messages {
  height: 100%;
  overflow-y: auto;
  padding-right: 10px;
}

.message {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.teacher-message {
  justify-content: flex-start;
}

.student-message {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.teacher-avatar {
  border: 2px solid #EEE2D8;
}

.student-avatar {
  border: 2px solid #C3A281;
}

.message-bubble {
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 8px;
  word-wrap: break-word;
  line-height: 1.4;
}

.teacher-bubble {
  background-color: #EEE2D8;
  color: #734719;
}

.student-bubble {
  background-color: #C3A281;
  color: #FFFFFF;
}

.input-area {
  padding: 15px 20px 20px 20px;
}

.input-container {
  background-image: url('@/assets/全球说/ques-input.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  aspect-ratio: 4/1;
  position: relative;
  display: flex;
  align-items: center;
}

.text-input-container,
.voice-input-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.text-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #C3A281;
  font-size: 14px;
  resize: none;
  height: 60%;
  padding: 5px;
}

.text-input::placeholder {
  color: #C3A281;
  opacity: 0.7;
}

.voice-input-area {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.voice-record-icon {
  height: 60px;
  cursor: pointer;
  transition: transform 0.2s;
}

.voice-record-icon:hover {
  transform: scale(1.1);
}

.input-controls {
  position: absolute;
  bottom: 20px;
  right: 30px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.control-divider {
  width: 1px;
  height: 20px;
  background-color: #C3A281;
}

.control-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s;
}

.control-icon:hover {
  transform: scale(1.1);
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #C3A281;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #A08660;
}
</style>
